// alert-dialog.component.ts
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'alert-dialog',
  templateUrl: 'alert-dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class AlertDialogComponent {
  @Input() title = 'Alert';
  @Input() confirmText?: string;
  @Input() cancelText?: string;

  @Input() isOpen = false;
  @Input() dimensionType: 'default' | 'wide' = 'default';

  @Output() onConfirm = new EventEmitter<void>();
  @Output() onCancel = new EventEmitter<void>();

  confirm() {
    this.onConfirm.emit();
    this.isOpen = false;
  }

  cancel() {
    this.onCancel.emit();
    this.isOpen = false;
  }

  close() {
    this.isOpen = false;
    this.onCancel.emit();
  }

  getWidthStyleString() {
    switch (this.dimensionType) {
      case 'wide':
        return 'max-w-5xl';
      case 'default':
        return 'max-w-md';
    }
  }
}
